import React from 'react';
import SlideBanner from '@components/common/SlideBanner/SlideBanner';
import ShareholderNav from '@components/Shareholder/ShareholderNav';
import ShareholderHome from '@components/Shareholder/ShareholderHome';
import {NextSeo} from 'next-seo';
import ShareholderCategoryService from '@services/shareholder-relationship-category.service';
import ShareholderNewsService from '@services/shareholder-relationship-news.service';
import AppConfig from '@services/app-config.service';
import {generateShareholderRelationshipListSEO} from '@helper/seo/generators/shareholder';
import {getLocaleContent} from '@helper/locale-content.js';
import {useRouter} from 'next/router';

export default function Shareholder(props) {
    const {seoPage} = props;
    const {locale} = useRouter();
    return (
        <>
            {seoPage && <NextSeo {...seoPage} />}
            <SlideBanner
                titleBanner={getLocaleContent(locale, 'page.shareholder-relations.title')}
                image="/bw_image/medial-facility.png"
            />
            <ShareholderNav />
            <ShareholderHome {...props} />
        </>
    );
}

Shareholder.PageName = 'SHARE-HOLDER';

Shareholder.getInitialProps = async context => {
    try {
        const ctx = context || {};
        const webUrl = process.env.NEXT_PUBLIC_WEB_URL || process.env.WEB_URL || 'https://tnh.com.vn';

        console.log('[Shareholder] Start getInitialProps', {locale: ctx.locale, query: ctx.query});
        let totalCount = 0;

        let categories = [];
        let newsByCategory = {};
        let shareholderContact = {};

        // SERVICES
        const appconfigService = new AppConfig(ctx);
        const shareholderCategoryService = new ShareholderCategoryService(ctx);
        const shareholderNewsService = new ShareholderNewsService(ctx);

        // ===============================
        // 1) FETCH SONG SONG (shareholder + category)
        // ===============================
        console.log('[Shareholder] Fetching shareholder list and category list in parallel...' + ctx.locale);
        let [appconfig, categoryRes] = await Promise.all([
            appconfigService
                .getAppConfig({page: 'HOME', locale: ctx.locale})
                .then(res => {
                    console.log('[Shareholder] appconfig received', res && (res.data ?? res));
                    return res;
                })
                .catch(e => {
                    console.error('[Shareholder] appconfig error:', e);
                    return null;
                }),
            shareholderCategoryService
                .getShareholerRelationshipCategoryOptions({
                    locale: ctx.locale || 'vn',
                })
                .then(res => {
                    console.log('[Shareholder] categoryRes received', res && (res.data ?? res));
                    return res;
                })
                .catch(e => {
                    console.error('[Shareholder] Category error:', e);
                    return null;
                }),
        ]);

        // ===============================
        // 2) PARSE CATEGORY
        // ===============================
        try {
            console.log('[Shareholder] Parsing categoryRes...' + categoryRes);
            if (categoryRes) {
                let payload = categoryRes.data?.data || categoryRes.data || categoryRes;
                console.log('[Shareholder] raw category payload:', payload);
                if (Array.isArray(payload)) {
                    categories = payload;
                } else if (payload.items && Array.isArray(payload.items)) {
                    categories = payload.items;
                }
            }
            console.log('[Shareholder] Parsed categories count:', categories.length);
        } catch (e) {
            console.error('[Shareholder] Parse category error:', e);
        }

        // ===============================
        // 3) LẤY NEWS CHO TẤT CẢ CATEGORY
        // ===============================
        try {
            console.log(
                '[Shareholder] Starting to fetch news for each category... total categories:',
                categories.length,
            );

            const newsPromises = categories.map(cat => {
                const catId = cat.category_id ?? null;
                console.log(`[Shareholder] Queue news fetch for category_id=${JSON.stringify(catId)}`);

                return shareholderNewsService
                    .getNewsByCategory({
                        locale: ctx.locale || 'vn',
                        page: 1,
                        page_size: 20,
                        id: Number(catId),
                    })
                    .then(res => {
                        let payload = res?.data?.data || res?.data || res || [];
                        console.log(`[Shareholder] news response for category ${catId}:`, payload);
                        newsByCategory[catId] = Array.isArray(payload) ? payload : payload.items || [];
                    })
                    .catch(e => {
                        console.error(`[Shareholder] News error for category ${catId}:`, e);
                        newsByCategory[catId] = [];
                    });
            });

            await Promise.all(newsPromises);
            console.log(
                '[Shareholder] All news fetched for categories. newsByCategory keys:',
                Object.keys(newsByCategory),
            );

            // ===============================
            // 2) PARSE APPCONFIG SHAREHOLDER
            // ===============================
            try {
                console.log('[Shareholder] Parsing appconfig...' + appconfig);
                if (appconfig) {
                    if (appconfig && typeof appconfig === 'object' && !Array.isArray(appconfig)) {
                        shareholderContact = appconfig;
                    }
                }
            } catch (e) {
                console.error('[Shareholder] Parse appconfig error:', e);
            }
        } catch (e) {
            console.error('[Shareholder] News fetch error:', e);
        }

        // ===============================
        // 5) SEO
        // ===============================
        console.log('[Shareholder] Generating SEO page with shareholder and category/news data...');
        console.log(categories);
        console.log(shareholderContact);
        console.log(newsByCategory);

        const seoPage = generateShareholderRelationshipListSEO(
            newsByCategory,
            categories,
            shareholderContact,
            totalCount,
            webUrl,
            categories,
        );
        console.log(
            '[Shareholder] SEO generated:',
            seoPage && {title: seoPage.title, description: seoPage.description},
        );

        const result = {seoPage, shareholderContact, categories, newsByCategory};

        return result;
    } catch (error) {
        console.error('[Shareholder] Failed to fetch SEO for job listing page:', error);

        const webUrl = process.env.NEXT_PUBLIC_WEB_URL || process.env.WEB_URL || 'https://tnh.com.vn';
        const seoPage = generateShareholderRelationshipListSEO([], 0, webUrl);
        console.log('[Shareholder] Returning fallback SEO and empty data');

        return {seoPage, categories: [], newsByCategory: {}};
    }
};
